import script from "./ReferralRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferralRegister.vue?vue&type=script&setup=true&lang=js"

import "./ReferralRegister.vue?vue&type=style&index=0&id=309c5676&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309c5676"]])

export default __exports__